export enum LoadState {
    NotLoaded,
    Loading,
    Loaded
}

/**
 * Since this is an enum, this must be kept in sync with the
 * server side equivalent enum. Including Order!
 */
export enum BidLoadState {
    NotSubmitted,
    Submitting,
    Success,
    ErrorOutbid,
    ErrorNoTime,
    ErrorOther,
    ErrorAccessDenied,
    ErrorAlreadyHighBidder,
    ErrorLogin
}

/**
 * These load states indicate that processing of a bid is not yet complete or has not been started.
 */
export const INCOMPLETE_BID_LOAD_STATES = Object.freeze([
    BidLoadState.NotSubmitted,
    BidLoadState.Submitting
]);

/**
 * These load states indicate that processing of a bid is complete.
 */
export const COMPLETED_BID_LOAD_STATES = Object.freeze([
    BidLoadState.Success,
    BidLoadState.ErrorOutbid,
    BidLoadState.ErrorNoTime,
    BidLoadState.ErrorOther,
    BidLoadState.ErrorAccessDenied,
    BidLoadState.ErrorAlreadyHighBidder,
    BidLoadState.ErrorLogin
]);

/**
 * These load states indicate something has gone wrong which should not occur under normal situations. These should
 * generate an exception for us to investigate and resolve.
 * */
export const CRITIAL_ERROR_BID_LOAD_STATES = Object.freeze([
    BidLoadState.ErrorOther,
    BidLoadState.ErrorAlreadyHighBidder,
    BidLoadState.ErrorNoTime
]);

export const isCriticalErrorBidLoadState = (state: BidLoadState): boolean => {
    if (CRITIAL_ERROR_BID_LOAD_STATES.includes(state)) {
        return true;
    }
    return false;
};

export const isCompletedBidLoadState = (state: BidLoadState): boolean => {
    if (INCOMPLETE_BID_LOAD_STATES.includes(state)) {
        return false;
    }
    return true;
};
